import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedFeeRelatedTermLoadingDesktop } from './desktop';
import { FixedFeeRelatedTermLoadingMobile } from './mobile';

export const FixedFeeRelatedTermLoading: React.FC = () => {
  return useBreakpointValue({
    base: <FixedFeeRelatedTermLoadingMobile />,
    sm: <FixedFeeRelatedTermLoadingMobile />,
    lg: <FixedFeeRelatedTermLoadingDesktop />,
  });
};
